export class CompanyLoanNumberApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getNextLoanNumber({ companyId }) {
    return this.#http.get(`/api/admin-panel/companies/${companyId}/loan-number/next`);
  }
}
